import React, { useState } from "react";
import LoadingSpinner from "../../../components/Loadder";
import { getData, postData } from "../../../serverRequest";
import DatePicker from "react-datepicker";

export default function TaskData(props) {
  const searchParams = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(false);
  const taskId = searchParams.get('task_id');
  const [userTaskId, setUserTaskId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [taskDate, setTaskDate] = useState();
  const [taskData, setTaskData] = useState();
  const [title, setTitle] = useState('Task Details');
  const [description, setDescription] = useState('');
  const [taskDatatype, setTaskDatatype] = useState();
  const [assignedTo, setAssignedTo] = useState('');
  const [dueDate, setDueDate] = useState();
  const [taskStatus, setTaskStatus] = useState();
  const [admins, setAdmins] = useState([]);
  const [createdBy, setCreatedBy] = useState();
  const [loggedInUser, setLoggedInUser] = useState(localStorage.getItem('employeeId')); // Assuming loggedInUser is passed as a prop
    //const [isEditable, setIsEditable] = useState(false);
  
    const handleSubmit = async (event) => {
      //Prevent page reload
      setLoading(true);
      event.preventDefault();
      let reqData = {
        'task_id': taskId ? taskId : 0,  
        'status': taskStatus,
        'title': title,
        'description': description,
        'assigned_to_id': assignedTo,
        'due_date': dueDate ? dueDate : ''
      }
  
      let resData = await postData('/api/tasks/', reqData);
      if (resData['data']['code'] === 200) {
        setLoading(false);
        setShowModal(true);
        window.location.href = '/admin/tasks';
      }
    };
  
    async function fetchEmployeeData() {
      let resData = await getData('/api/employee/?company_id=1&is_list_employee=1');
      let admins_data = resData['data']['employee_data'];
      console.log(admins_data);
      setAdmins(admins_data ? admins_data : []); // Always set as array
  
      setLoading(false);
    }
  

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let resData = await getData('/api/tasks/?task_id=' + taskId)
      let tasks_data = resData['data']['data'][0];
      console.log(tasks_data);
      if (tasks_data) {
        setTaskDate(tasks_data['date']);
        setTaskData(tasks_data['task']);
        setTaskStatus(tasks_data['status']);
        setTitle(tasks_data['title']);
        setDescription(tasks_data['description']);
        setAssignedTo(tasks_data['assigned_to']);
        setDueDate(tasks_data['due_date']);
        setUserTaskId(tasks_data['task_id']);
        setCreatedBy(tasks_data['created_by']);

      }

      setLoading(false);
    }
    fetchData();
    fetchEmployeeData();

  }, [])

  return (
    <div className="task-details-container p-4 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">Task ID : {userTaskId}</h6>
              </div>
            </div>
            {/* First Line: Title */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-1/12 px-4 mb-3">
                <div className="relative w-full mb-1">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Title {loggedInUser} {createdBy}</label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    readOnly={String(loggedInUser) !== String(createdBy)}
                  />
                </div>
              </div>
            </div>
            {/* Second Line: Assigned To and Due Date */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4 mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Assigned To</label>
                {loggedInUser == createdBy ? (
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="assigned_to"
                    value={assignedTo}
                    onChange={(e) => setAssignedTo(e.target.value)}
                  >
                    <option value="">Select Admin</option>
                    {admins.map((admin) => (
                      <option key={admin.id} value={admin.id}>
                        {admin.first_name} {admin.last_name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="assigned_to"
                    value={assignedTo}
                    readOnly
                  />
                )}
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Due Date</label>
                  <input
                    type="date"
                    value={dueDate ? dueDate : ''}
                    onChange={(e) => setDueDate(new Date(e.target.value))}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    readOnly={loggedInUser != createdBy}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4 mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Status</label>
                {String(loggedInUser) === String(assignedTo) ? (
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="status"
                    value={taskStatus}
                    onChange={(e) => setTaskStatus(e.target.value)}
                  >
                    <option value="pending">Pending</option>
                    <option value="in_progress">In Progress</option>
                    <option value="completed">Completed</option>
                  </select>
                ) : (
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="status"
                    value={taskStatus}
                    readOnly
                  />
                )}
              </div>
            </div>
            {/* Third Line: Description */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-10/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Description</label>
                  <textarea
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    readOnly={loggedInUser !== createdBy}
                  />
                </div>
              </div>
            </div>
            {/* Submit Button */}
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
